import React from 'react';

interface MetricBoxProps {
  label: string;
  value: string | number;
  icon?: React.ComponentType<{ className?: string }>;
  color?: 'blue' | 'emerald' | 'amber' | 'red' | 'slate';
  subtext?: string;
}

const colorClasses = {
  blue: 'bg-blue-50 border-blue-200/50 text-blue-900',
  emerald: 'bg-emerald-50 border-emerald-200/50 text-emerald-900',
  amber: 'bg-amber-50 border-amber-200/50 text-amber-900',
  red: 'bg-red-50 border-red-200/50 text-red-900',
  slate: 'bg-slate-50 border-slate-200/50 text-slate-900',
};

export const MetricBox: React.FC<MetricBoxProps> = ({
  label,
  value,
  icon: Icon,
  color = 'slate',
  subtext,
}) => {
  return (
    <div className={`p-4 rounded-lg border ${colorClasses[color]}`}>
      <div className="flex items-center gap-2 mb-1">
        {Icon && <Icon className="h-4 w-4 opacity-60" />}
        <span className="text-xs opacity-70">{label}</span>
      </div>
      <p className="text-lg font-semibold">{value}</p>
      {subtext && <p className="text-xs opacity-60 mt-1">{subtext}</p>}
    </div>
  );
};
